export enum TrialStatus {
  ACTIVE = 'Active',
  SCHEDULED = 'Scheduled',
  CANCELLED = 'Canceled',
  EXPIRED = 'Expired',
}
